import { composeIO } from 'react-compose-io'
import { historicoRegularizacaoIO } from './HistoricoRegularizacao.IO'
import { HistoricoRegularizacaoView } from './HistoricoRegularizacao.View'

export const HistoricoRegularizacao = composeIO(HistoricoRegularizacaoView, historicoRegularizacaoIO)
